<div
  class="info-banner"
  [ngClass]="{
    'info-banner--demo': type === 'demo',
    'info-banner--trial': type === 'trial',
    'info-banner--license-expiring': type === 'license-expiring',
    'info-banner--license-expired': type === 'license-expired' || type === 'trial-expired'
  }"
  *transloco="let t"
>
  <ng-container [ngSwitch]="type">
    <div *ngSwitchCase="'trial'" class="trial-row">
      <i class="material-symbols-rounded text-primary filled">alarm</i>
      <div>
        <span
          *ngIf="daysLeft > 1; else expiresToday"
          [innerHtml]="t('infoBanner/trialExpiresIn', {daysLeft, section: t('section/pap')})"
        ></span>
        <ng-template #expiresToday>
          {{ t('infoBanner/trialExpiresToday') }}
        </ng-template>
        <span *ngIf="canRenew" (click)="handleRedirectToPriceList()">
          &nbsp;<span class="link">{{ t('infoBanner/redirectToPriceList') }}</span>
        </span>
      </div>
    </div>
    <div *ngSwitchCase="'license-expiring'" class="license-row">
      <i class="material-symbols-rounded text-primary filled">alarm</i>
      <div class="license-content">
        <span [innerHtml]="t('infoBanner/licenseExpiresIn', { daysLeft, section: t('section/pap') })"></span>
        <span *ngIf="canRenew; else teacherInfo" class="link" (click)="handleRedirectToPriceList()">
          {{ t('infoBanner/renewLicense') }}
        </span>
        <ng-template #teacherInfo>
          <span class="teacher-note">{{ t('infoBanner/contactDirectorOrAdmin') }}</span>
        </ng-template>
      </div>
    </div>
    <div *ngSwitchCase="'license-expired'" class="license-row">
      <i class="material-symbols-rounded text-primary filled">warning</i>
      <div class="license-content">
        <span [innerHtml]="t('infoBanner/licenseExpiredBefore', { section: t('section/pap') })"></span>
        <span *ngIf="canRenew; else teacherInfoExpired" class="link" (click)="handleRedirectToPriceList()">
          {{ t('infoBanner/renewLicense') }}
        </span>
        <ng-template #teacherInfoExpired>
          <span class="teacher-note">{{ t('infoBanner/contactDirectorOrAdmin') }}</span>
        </ng-template>
      </div>
    </div>
    <div *ngSwitchCase="'trial-expired'" class="license-row">
      <i class="material-symbols-rounded text-primary filled">warning</i>
      <div class="license-content">
        <span [innerHtml]="t('infoBanner/trialExpired', { section: t('section/pap') })"></span>
        <span *ngIf="canRenew; else teacherInfoTrialExpired" class="link" (click)="handleRedirectToPriceList()">
          {{ t('infoBanner/redirectToPriceList') }}
        </span>
        <ng-template #teacherInfoTrialExpired>
          <span class="teacher-note">{{ t('infoBanner/contactDirectorOrAdmin') }}</span>
        </ng-template>
      </div>
    </div>
    <div *ngSwitchCase="'demo'" class="text-uppercase">
      {{ t('shared/demoKindergarten') }}
    </div>
  </ng-container>
</div>
